module.exports = __webpack_public_path__ + "59ad83481541ff1bcf2f599ed2660088.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/server-product/images/tu.png
// module id = 2474
// module chunks = 31